import React, { useEffect, useState } from "react";
import { GetpatientVitals } from "../../../api/helper";
import { useSelector } from "react-redux";

const DetailsVitalsPatient = () => {
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [data, setdata] = useState([])
 const profiledata = useSelector((state) => state?.cookies?.userDetails);
  const toggleFormVisibility = () => {
    setIsFormVisible(!isFormVisible);
  };

    const Getdata = async () => {
      try {
        const respo = await GetpatientVitals(profiledata?._id);
        setdata(respo?.data?.data?.data);
      } catch (error) {
        console.log(error);
      }
    };
    useEffect(() => {
      Getdata();
    }, []);
  return (
    <div className="patient_right">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          alignSelf: "flex-end",
          marginTop: 20,
          marginRight: 20,
        }}
      >
        <img src={require("../../assest/Images/NKDA_icon.png")} />
        <div className="view_Prescriptions_txt">NKDA</div>
        <div
          className="custom-problem-add-button_two"
          onClick={toggleFormVisibility}
        >
          <img
            src={require("../../assest/Images/plus_icon.png")}
            style={{ marginRight: 10, filter: "invert(1) brightness(5)" }}
          />{" "}
          Add
        </div>
      </div>
       <div className="vitals-list_Vitals">
        <table>
          <thead>
            <tr>
              <th>Recorded Date</th>
              <th>BP</th>
              <th>HR</th>
              <th>RR</th>
              <th>Temp</th>
              <th>SpO2</th>
              <th>Weight</th>
              <th>Height</th>
              <th>BMI</th>
              <th>Peak Flow</th>
              <th>Waist Circumference</th>
              <th>Head Circumference</th>
          
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan="13">No vitals recorded yet.</td>
              </tr>
            ) : (
              data.map((item, index) => (
                <tr key={item._id || index}>
                  <td>{new Date(item.RecordedOnDate).toLocaleDateString()}</td>
                  <td>
                    {item.BloodPressure.systolic +
                      " / " +
                      item.BloodPressure.diastolic}
                  </td>
                  <td>{item.HeartRate}</td>

                  <td>{item.RespiratoryRate}</td>
                  <td>{item.Temperature}</td>
                  <td>{item.Sp02}</td>
                  <td>{item.Weight}</td>
                  <td>{item.Height}</td>
                  <td>{item.BMI}</td>
                  <td>{item.PeakFlow}</td>
                  <td>{item.WaistCircumference}</td>
                  <td>{item.HeadCircumference}</td>
             
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {isFormVisible && (
        <div className="add_problem_div2">
          <div className="Add_problem_txtt1">
            Add Vitals
            {/* Close Icon */}
            <img
              src={require("../../assest/Images/crossIconn.png")}
              alt="close"
              onClick={toggleFormVisibility} // Hides form when clicked
              style={{ cursor: "pointer" }}
            />
          </div>
          <p className="Record_Details_txt">Record Details</p>
          <div className="div_input_Blood_txt">
            <div className="dic_Blood_txt">
              <p className="Blood_txt">Blood Pressure</p>
            </div>
            <input type="text" className="input_txt" placeholder="0  mmHg" />
            <input type="text" className="input1_txt" placeholder="0  mmHg" />
          </div>
          <div className="div_input_Blood_txt">
            <div className="dic_Blood_txt">
              <p className="Blood_txt">Heart Rate</p>
            </div>
            <input type="text" className="input_txt" placeholder="0  bpm" />
          </div>

          <div className="div_input_Blood_txt">
            <div className="dic_Blood_txt">
              <p className="Blood_txt">Respiratory Rate</p>
            </div>
            <input type="text" className="input_txt" placeholder="0  bpm" />
          </div>
          <div className="div_input_Blood_txt">
            <div className="dic_Blood_txt">
              <p className="Blood_txt">Temperature</p>
            </div>
            <input type="text" className="input_txt" placeholder="0  bpm" />
          </div>
          <div className="div_input_Blood_txt">
            <div className="dic_Blood_txt">
              <p className="Blood_txt">Sp02</p>
            </div>
            <input type="text" className="input_txt" placeholder="0  bpm" />
          </div>
          <div className="div_input_Blood_txt">
            <div className="dic_Blood_txt">
              <p className="Blood_txt">Weight</p>
            </div>
            <input type="text" className="input_txt" placeholder="0  bpm" />
          </div>
          <div className="div_input_Blood_txt">
            <div className="dic_Blood_txt">
              <p className="Blood_txt">Blood Pressure</p>
            </div>
            <input type="text" className="input_txt" placeholder="0  ft" />
            <input type="text" className="input1_txt" placeholder="0  in" />
          </div>
          <div className="div_input_Blood_txt">
            <div className="dic_Blood_txt">
              <p className="Blood_txt">BMI</p>
            </div>
            <input type="text" className="input_txt" placeholder="0  bpm" />
          </div>
          <div className="div_input_Blood_txt">
            <div className="dic_Blood_txt">
              <p className="Blood_txt">Peak Flow</p>
            </div>
            <input type="text" className="input_txt" placeholder="0  bpm" />
          </div>
          <div className="div_input_Blood_txt">
            <div className="dic_Blood_txt">
              <p className="Blood_txt">Waist Circumference</p>
            </div>
            <input type="text" className="input_txt" placeholder="0  bpm" />
          </div>
          <div className="div_input_Blood_txt">
            <div className="dic_Blood_txt">
              <p className="Blood_txt">Head Circumference</p>
            </div>
            <input type="text" className="input_txt" placeholder="0  bpm" />
          </div>
          <div className="div_input_Blood_txt1">
            <div className="dic_Blood_txt">
              <p className="Blood_txt">Memo</p>
            </div>
            <input type="text" className="input_txt1" />
          </div>
          <p className="Recorded_On_txt">Recorded On</p>

          <div className="div_input_Blood_txt">
            <p className="Blood_txt">Use Current Date and Time</p>
            <img
              className="Image_notificaton"
              src={require("../../assest/Images/Notification.png")}
            />
          </div>

          <div className="div_input_Blood_txt">
            <div className="dic_Blood_txt">
              <p className="Blood_txt">Date</p>
            </div>
            <input type="text" className="input_txt" placeholder="dd/mm/yy" />
          </div>
          <div className="div_input_Blood_txt">
            <div className="dic_Blood_txt">
              <p className="Blood_txt">Time</p>
            </div>
            <input type="text" className="input_txt" placeholder="--:-- --" />
          </div>

          <div className="div_button">
            <p className="button_Canclel">Cancel</p>
            <p className="button_Save">Save</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default DetailsVitalsPatient;
